"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var react_registry_1 = require("react-registry");
var TypeUtils_1 = require("./util/TypeUtils");
exports.SCHEMA = "__schema__";
exports.providerConditions = { override: true };
exports.setupSchema = function (clazz) {
    var key = getSchemaKey(clazz.constructor);
    if (typeof clazz[key] === "undefined") {
        clazz[key] = { properties: [] };
    }
    return key;
};
function getSchemaKey(clazz) {
    return exports.SCHEMA + clazz.name;
}
exports.getSchemaKey = getSchemaKey;
exports.generateSchema = function (clazz, conditions, excluded) {
    var key = getSchemaKey(clazz);
    var instance = new clazz();
    if (typeof instance === "object" && typeof instance[key] === "object") {
        var data_1 = {
            description: instance.__proto__[key].description,
            properties: [],
            title: instance.__proto__[key].title
        };
        findInherited(instance, function (s) {
            data_1.properties = s.properties.concat(data_1.properties);
        });
        var schema_1 = { title: data_1.title, description: data_1.description };
        var uiSchema_1 = {};
        var fields_1 = {};
        schema_1.type = "object";
        schema_1.properties = {};
        schema_1.required = data_1.properties.filter(function (p) { return p.required && (!excluded || !lodash_1.includes(excluded, p.id)); }).map(function (p) { return p.id; });
        var provider_1 = new react_registry_1.Provider({
            registry: "decorator-form",
            conditions: TypeUtils_1.iDef(conditions) ? __assign({}, conditions, exports.providerConditions) : exports.providerConditions
        });
        data_1.properties.forEach(function (p) {
            if (excluded && lodash_1.includes(excluded, p.id)) {
                return;
            }
            var fieldWrapper = provider_1.get(p.type);
            if (TypeUtils_1.iDef(fieldWrapper)) {
                schema_1.properties[p.id] = __assign({}, p, { id: undefined, required: undefined, type: fieldWrapper.getDataType() });
                var field = fieldWrapper.getUiField();
                if (TypeUtils_1.iDef(field)) {
                    uiSchema_1[p.id] = (_a = {}, _a["ui:field"] = p.id, _a);
                    fields_1[p.id] = field;
                }
                else {
                    var widget = fieldWrapper.getUiWidget();
                    if (TypeUtils_1.iDef(widget)) {
                        uiSchema_1[p.id] = (_b = {}, _b["ui:widget"] = widget, _b);
                    }
                    var array = fieldWrapper.isArray();
                    if (TypeUtils_1.iDef(array)) {
                        schema_1.properties[p.id] = __assign({}, schema_1.properties[p.id], { items: { type: fieldWrapper.getArrayType() } });
                    }
                }
                var label = fieldWrapper.isLabel();
                if (TypeUtils_1.iDef(label)) {
                    uiSchema_1[p.id] = __assign({}, uiSchema_1[p.id], (_c = {}, _c["ui:options"] = { label: label }, _c));
                }
            }
            var _a, _b, _c;
        });
        return { schema: schema_1, uiSchema: uiSchema_1, fields: fields_1 };
    }
    throw Error("Invalid class supplied. Make sure you are not passing an object instead.");
};
function findInherited(instance, callback) {
    Object.keys(instance.__proto__).filter(function (k) { return k.startsWith(exports.SCHEMA); }).forEach(function (k) {
        callback(instance[k]);
        return findInherited(instance.__proto__, callback);
    });
}
//# sourceMappingURL=generate.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/decorator-form/dist/generate.js
// module id = 325
// module chunks = 0